<div class="dialog-container" [class.compact]="data.hideCloseButton">
  <div  class="dialog-header">
    <h4 [style.color]="data.isError ? '#f44336' : null">{{ data.title }}</h4>
    <button *ngIf="!data.hideCloseButton" mat-icon-button class="close-button" (click)="onDismiss()" matTooltip="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <p *ngIf="data.message">{{ data.message }}</p>

    <div class="dialog-inputs" *ngIf="data.inputs?.length">
      <label class="dialog-input-field" *ngFor="let input of data.inputs">
        <span *ngIf="input.label">
          {{ input.label }}
          <span class="required" *ngIf="input.required">*</span>
        </span>

        <textarea
          *ngIf="input.type === 'textarea'; else standardInput"
          [(ngModel)]="inputValues[input.key]"
          (blur)="inputTouched[input.key] = true"
          [placeholder]="input.placeholder || ''"
          [attr.maxlength]="input.maxLength || null"
          rows="3"
        ></textarea>

        <ng-template #standardInput>
          <input
            [type]="input.type || 'text'"
            [(ngModel)]="inputValues[input.key]"
            (blur)="inputTouched[input.key] = true"
            [placeholder]="input.placeholder || ''"
            [attr.maxlength]="input.maxLength || null"
            autofocus
          />
        </ng-template>

        <small class="dialog-input-error" *ngIf="isInputInvalid(input)">
          This field is required.
        </small>
      </label>
    </div>
  </div>

  <div class="dialog-actions" *ngIf="data.showActions === undefined || data.showActions">
    <button mat-stroked-button class="cancel-button"  (click)="onDismiss()">
      {{ data.cancelLabel || 'Cancel' }}
    </button>
    <button mat-flat-button class="confirm-button"   (click)="onConfirm()">
      {{ data.confirmLabel || 'Confirm' }}
    </button>
  </div>
</div>
